<template>
  <component
    :is="emptyComponent"
    :md-label="label"
    :md-description="description"
    :md-icon="icon"
    class="loadable-content"
    v-bind="$attrs"
  >
    <md-progress-spinner v-if="loading && !error" md-mode="indeterminate" />
    <slot v-else></slot>
  </component>
</template>

<script>
export default {
  name: "LoadingContent",

  inheritAttrs: false,

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    loadingDescription: {
      type: String,
      default: null,
    },
    loadingLabel: {
      type: String,
      default: null,
    },
    loadingIcon: {
      type: String,
      default: "",
    },
    errorIcon: {
      type: String,
      default: "error_outline",
    },
    errorLabel: {
      type: String,
      default: "Error",
    },
    errorDescription: {
      type: String,
      default: "Hubo un error cargando los datos.",
    },
    emptyIcon: {
      type: String,
      default: "refresh",
    },
    emptyLabel: {
      type: String,
      default: "Nada que mostrar.",
    },
    emptyDescription: {
      type: String,
      default: "",
    },
    table: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    label() {
      return this.error
        ? this.errorLabel
        : this.loading
        ? this.loadingLabel
        : this.emptyLabel;
    },
    icon() {
      return this.error
        ? this.errorIcon
        : this.loading
        ? this.loadingIcon
        : this.emptyIcon;
    },
    description() {
      return this.error
        ? this.errorDescription
        : this.loading
        ? this.loadingDescription
        : this.emptyDescription;
    },
    emptyComponent() {
      return !this.table ? "md-empty-state" : "md-table-empty-state";
    },
  },
};
</script>

<style lang="scss" scoped>
.component.loadable-content {
  height: 100%;
  max-height: 560px;
  .md-icon-font {
    font-size: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingContent.vue